const updateUrlParam = (params) => {
  let url = new URL(window.location.href);

  url.search = params;
  url = url.toString();
  window.history.replaceState({ url }, null, url);
};

export default updateUrlParam;
